import { Box, ClickAwayListener, FormControl, InputLabel, MenuItem, MenuList, Select } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header id='header'>
      <div className='container d-flex align-items-center'>
        <h1 className='logo mr-auto d-flex align-items-center'>
          <img src='/assets/img/logo.png' alt='Formrally.com' className='img-fluid mr-2' />
          <Link to='/'>
            Beyond<span style={{ color: '#bbd75b' }}>Oil</span>
          </Link>
        </h1>

        {/* <nav className='nav-menu d-none d-lg-block'>
          <Link
            to={'/profile'}
            style={{ fontSize: '1.5rem' }}
            className='btn btn-lg btn-outline-light border-0'
            title='Account'
          >
            <i className='fa-regular fa-user'></i>
          </Link>
        </nav> */}
      </div>
    </header>
  );
};

export default Header;
